const tabsClass = ".careers__tabs";
const mobileBreakpoint = "768px";

function createCareersTabs() {
  let buttons;
  let tabs;
  let contentContainer;
  let activeIndex = 0;

  let container;
  let containerTop;
  let siteHeader;
  let siteHeaderHasTransition = false;
  let pastStickyThreshold = false;
  let scrollY = 0;
  let scrollDirection = "down";

  function init() {
    document.addEventListener("DOMContentLoaded", () => {
      container = document.querySelector(`${tabsClass}--buttons`);
      if (!container) return;

      containerTop = container.getBoundingClientRect().top + window.scrollY;

      siteHeader = document.querySelector("header");
      siteHeader.classList.add("careers__site-header");

      buttons = Array.from(
        document.querySelectorAll(`${tabsClass}--buttons-list-button`)
      );
      tabs = Array.from(document.querySelectorAll(`${tabsClass}--content`));
      contentContainer = document.querySelector(
        `${tabsClass}--content-container`
      );

      if (!buttons.length || !tabs.length) return;

      buttons.forEach((button) => {
        button.addEventListener("click", () => {
          if (isActiveTab(button)) return;

          setActiveTab(button);
          updateURL(button);
          if (window.scrollY > containerTop) {
            window.scrollTo({
              top: containerTop - siteHeader.offsetHeight + 1,
            });
          }
        });
      });

      attachScrollListener();
      attachPopStateListener();
      attachResizeListener();
      handleInitialURL();
    });
  }

  function handleInitialURL() {
    const query = location.search;
    let currentButton = buttons[0];
    if (query) {
      const parsedTabLabel = decodeURIComponent(query.split("=")[1]);
      currentButton = buttons.find(
        (button) => button.textContent.trim() === parsedTabLabel
      );
      if (!currentButton) return;
    } else {
      updateURL(currentButton);
    }
    setActiveTab(currentButton);
  }

  function updateURL(button) {
    const tabIndex = button.dataset.tabButtonIndex;
    const tabLabel = button.textContent.trim();
    history.pushState({ tabIndex }, "", `?tab=${encodeURIComponent(tabLabel)}`);

    const documentTitle = document.title.split(" | ");
    documentTitle[0] = tabLabel;
    document.title = documentTitle.join(" | ");
  }

  function attachPopStateListener() {
    window.addEventListener("popstate", (e) => {
      if (!e.state.tabIndex) return;
      setActiveTab(parseInt(e.state.tabIndex));
    });
  }

  function setActiveTab(button) {
    const nextIndex = parseInt(button.dataset.tabButtonIndex);
    handleButtonUpdates(nextIndex);
    handleContentUpdates(nextIndex);
    activeIndex = nextIndex;
  }

  function handleButtonUpdates(nextIndex) {
    const currentButton = buttons.find(
      (button) => parseInt(button.dataset.tabButtonIndex) === activeIndex
    );
    const nextButton = buttons.find(
      (button) => parseInt(button.dataset.tabButtonIndex) === nextIndex
    );

    if (!currentButton || !nextButton) return;

    currentButton.classList.remove("active-button");
    currentButton.setAttribute("aria-selected", false);
    nextButton.classList.add("active-button");
    nextButton.setAttribute("aria-selected", true);
  }

  function handleContentUpdates(nextIndex) {
    const currentContent = tabs.find(
      (tab) => parseInt(tab.dataset.tabContentIndex) === activeIndex
    );
    const nextContent = tabs.find(
      (tab) => parseInt(tab.dataset.tabContentIndex) === nextIndex
    );

    if (!currentContent || !nextContent) return;

    currentContent.classList.remove("active-tab");
    nextContent.classList.add("active-tab");
  }

  function attachScrollListener() {
    const mql = window.matchMedia(`max-width: ${mobileBreakpoint}`);
    if (mql.matches) return;
    window.removeEventListener("scroll", handleScroll);
    window.addEventListener("scroll", handleScroll);
  }

  function handleScroll() {
    if (scrollY < window.scrollY) scrollDirection = "down";
    if (scrollY > window.scrollY) scrollDirection = "up";
    scrollY = window.scrollY;

    if (scrollY > containerTop) pastStickyThreshold = true;
    if (pastStickyThreshold && scrollY < containerTop - siteHeader.offsetHeight)
      pastStickyThreshold = false;

    const isSticky = window.scrollY >= containerTop - siteHeader.offsetHeight;
    if (!isSticky) {
      container.style.top = "0px";
      return;
    }

    // we manually translate the header translate until we are above the Tab component's "sticky threshold" (containerTop)
    // -- this is so the two components move together (the header is a separate component, using Knockout, that doesn't know anything about Tabs)
    const isTransitionPhase =
      isSticky &&
      scrollY <= containerTop &&
      !getHeaderVisible(siteHeader.offsetHeight);
    if (isTransitionPhase) {
      siteHeader.classList.remove("animate-translate");
      const dy = siteHeader.offsetHeight - Math.abs(scrollY - containerTop);
      const siteHeaderOffset = Math.min(dy, siteHeader.offsetHeight);
      siteHeader.style.transform = `translateY(-${siteHeaderOffset}px)`;
      container.style.top = "0px";
      return;
    }
    // don't add class with CSS transition until we're above "sticky threshold" either
    handleSiteHeaderTransition(scrollY > containerTop);

    // normal handling of header and tab styles
    container.style.top =
      scrollDirection === "up" ? `${siteHeader.offsetHeight}px` : "0px";
    siteHeader.style.transform =
      scrollDirection === "up"
        ? "translateY(0px)"
        : `translateY(-${siteHeader.offsetHeight}px)`;
  }

  function getHeaderVisible(siteHeaderHeight) {
    if (scrollDirection !== "up") return false;
    const thresholdToCheck = pastStickyThreshold
      ? containerTop - siteHeaderHeight
      : containerTop;
    return scrollY > thresholdToCheck;
  }

  function handleSiteHeaderTransition(shouldAddClass) {
    if (shouldAddClass && !siteHeaderHasTransition) {
      siteHeader.classList.add("animate-translate");
      siteHeaderHasTransition = true;
    } else if (!shouldAddClass && siteHeaderHasTransition) {
      siteHeader.classList.remove("animate-translate");
      siteHeaderHasTransition = false;
    }
  }

  function isActiveTab(button) {
    return parseInt(button.dataset.tabButtonIndex) === activeIndex;
  }

  function attachResizeListener() {
    window.addEventListener("resize", () => {
      setTimeout(() => {
        attachScrollListener();
      }, 1000);
    });
  }

  return { init };
}

const careersTabs = createCareersTabs();
careersTabs.init();
